import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailAiPromptService {
  public focusOnPromptInput$ = new Subject<void>();
}
